export const CREATE_VENDOR_ACTION = '[Vendor Action] Create Vendor';
export const CONFIRMED_CREATE_VENDOR_ACTION = '[Vendor Action] Confirmed Create Vendor';
export const CREATE_VENDOR_ERROR_ACTION='[Vendor Action] Create Vendor Error';
export const GET_VENDORS = '[Vendor Action] Get Vendors';
export const CONFIRMED_GET_VENDORS = '[Vendor Action] Confirmed Get Vendors';
export const CONFIRMED_GET_VENDOR = '[Vendor Action] Confirmed Get Vendor';
export const LOADING_VENDORS = '[Vendor Action] Loading for Vendors';
export const EDIT_VENDOR_ACTION = '[Vendor Action] Edit Vendor';
export const CONFIRMED_EDIT_VENDOR_ACTION = '[Vendor Action] Confirmed Edit Vendor';
export const DELETE_VENDOR_ACTION = '[Vendor Action] Delete Vendor';
export const CONFIRMED_DELETE_VENDOR_ACTION = '[Vendor Action] Confirmed Delete Vendor';
export const VENDOR_ERROR_ACTION = '[Vendor Action] Error';
export const CLEAR_VENDOR_ERROR = '[Vendor Action] Clear Error';
export const CONFIRMED_UPDATE_PLAN_STATUS_ACTION = '[Vendor Action] Update Status';


